import { Decimal } from "decimal.js-light";

export const convertStringToDecimal = (decimalString: string) => {
  // Replaces just the first occurrence of ',', by converting it to $ as a placeholder and then omitting all other decimal separators
  let str = decimalString.trim();
  if (str.includes(",") && str.includes(".")) {
    str = str
      .replace(",", "$")
      .replaceAll(",", "")
      .replaceAll(".", "")
      .replace("$", ".");
  } else {
    str = str.replaceAll(",", ".");
  }
  try {
    return new Decimal(str);
  } catch (e) {
    throw new Error(
      `Failed to parse decimal. raw="${decimalString}" (type=${typeof decimalString}), processed="${str}", rawChars=${Array.from(decimalString).map((c) => c.codePointAt(0)?.toString(16)).join(",")}`
    );
  }
};

export const convertDecimalToString = (decimalInput: Decimal) => {
  return decimalInput.toNumber().toLocaleString("da-DK");
};
